import React from 'react';
import OBSOLATE_GameScoreBoard from '../OBSOLATE_GameScoreBoard.js';
import {_GPY,__GPYPost} from '../../../env.js'
import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyScoreField from '../lib/GpyScoreField.js';
import GpyTeamSelect from '../lib/GpyTeamSelect.js'

import GpyTeamList from '../lib/GpyTeamList.js';
import Display from '../../display/Display.js';
import WaitCube from '../../../WaitCube'
import moment from 'moment';
import 'moment/locale/de';
import { saveAs } from 'file-saver'

import OBS from '../../OBS.js'

class SBDrift extends OBSOLATE_GameScoreBoard {

	constructor(props) {
		super(props);
		this.state = super.getGPYState("Drift");
		this.state.dataStore = {player:{},battle:{"_32":[],"_16":[],"_8":[],"_4":[],"_2":[],"_1":[]}};
		this.state.defaultDataStore = {player:{},battle:{"_32":[],"_16":[],"_8":[],"_4":[],"_2":[],"_1":[]}};
		this.state.battleBoardMode = false;
	}

	componentDidMount() {
		super.getGamesStates();
		super.getGames();
		super.getAdvertisements();
		super.getLayouts();
	}

	onSelectPlayer(player) {
		var s = this.state;
		s.selectedPlayers[player.vsRole] = player;
		this.doChangeValue(player,undefined,"onSelectPlayer");
		this.setState({selectedPlayers : s.selectedPlayers});
	}


  playerContains(p,a,b,c) {
		console.log("CONTAINS",a,b,c);
		if(a !== undefined && a.id === p.id ) return true;
		if(b !== undefined && b.id === p.id ) return true;
		return false;
	}

	calcTop32(){
			var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
			players = players.slice(0,32);

			if(players.length>1) this.state.dataStore.battle._32[1] =  players[1-1].id;
			if(players.length>32-1) this.state.dataStore.battle._32[2] =  players[32-1].id;

			if(players.length>2) this.state.dataStore.battle._32[3] =  players[5-1].id;
			if(players.length>31-1) this.state.dataStore.battle._32[4] =  players[28-1].id;

			if(players.length>3-1) this.state.dataStore.battle._32[5] =  players[9-1].id;
			if(players.length>30-1) this.state.dataStore.battle._32[6] =  players[24-1].id;

			if(players.length>4-1) this.state.dataStore.battle._32[7] =  players[13-1].id;
			if(players.length>29-1) this.state.dataStore.battle._32[8] =  players[20-1].id;

			if(players.length>5-1) this.state.dataStore.battle._32[9] =  players[15-1].id;
			if(players.length>28-1) this.state.dataStore.battle._32[10] =  players[18-1].id;

			if(players.length>6-1) this.state.dataStore.battle._32[11] =  players[11-1].id;
			if(players.length>27-1) this.state.dataStore.battle._32[12] =  players[22-1].id;

			if(players.length>7-1) this.state.dataStore.battle._32[13] =  players[7-1].id;
			if(players.length>26-1) this.state.dataStore.battle._32[14] =  players[26-1].id;

			if(players.length>8-1) this.state.dataStore.battle._32[15] =  players[3-1].id;
			if(players.length>25-1) this.state.dataStore.battle._32[16] =  players[30-1].id;

			if(players.length>9-1) this.state.dataStore.battle._32[17] =  players[2-1].id;
			if(players.length>24-1) this.state.dataStore.battle._32[18] =  players[31-1].id;

			if(players.length>10-1) this.state.dataStore.battle._32[19] =  players[6-1].id;
			if(players.length>23-1) this.state.dataStore.battle._32[20] =  players[27-1].id;

			if(players.length>11-1) this.state.dataStore.battle._32[21] =  players[10-1].id;
			if(players.length>22-1) this.state.dataStore.battle._32[22] =  players[23-1].id;

			if(players.length>12-1) this.state.dataStore.battle._32[23] =  players[14-1].id;
			if(players.length>21-1) this.state.dataStore.battle._32[24] =  players[13-1].id;

			if(players.length>13-1) this.state.dataStore.battle._32[25] =  players[16-1].id;
			if(players.length>20-1) this.state.dataStore.battle._32[26] =  players[17-1].id;

			if(players.length>14-1) this.state.dataStore.battle._32[27] =  players[12-1].id;
			if(players.length>19-1) this.state.dataStore.battle._32[28] =  players[21-1].id;

			if(players.length>15-1) this.state.dataStore.battle._32[29] =  players[8-1].id;
			if(players.length>18-1) this.state.dataStore.battle._32[30] =  players[25-1].id;

			if(players.length>16-1) this.state.dataStore.battle._32[31] =  players[4-1].id;
			if(players.length>17-1) this.state.dataStore.battle._32[32] =  players[29-1].id;

			this.forceUpdate();
	}

	getMaxValue(r) {
		return Math.max(...r);
	}

	sortPlayer(l,player) {
		const dsp = player;
	  l.sort( (a, b) => {
					if(dsp!==undefined) {

					if(dsp[a.id]!==undefined && dsp[b.id]!==undefined && dsp[a.id].quailifying_score!==undefined && dsp[b.id].quailifying_score!==undefined) {
						if(this.getMaxValue(dsp[a.id].quailifying_score) === this.getMaxValue(dsp[b.id].quailifying_score)) {
							return (""+a.lastName).localeCompare(b.lastName);
						}
						return this.getMaxValue(dsp[b.id].quailifying_score) - this.getMaxValue(dsp[a.id].quailifying_score);
					}
					else if(dsp[a.id]!==undefined && dsp[a.id].quailifying_score!==undefined && (dsp[b.id]===undefined || dsp[b.id].quailifying_score===undefined)) {
						return -1;
					}
					else if(dsp[b.id]!==undefined && dsp[b.id].quailifying_score!==undefined && (dsp[a.id]===undefined || dsp[a.id].quailifying_score===undefined)) {
						return 1;
					}
			  }
				/*
				if( a._config.score!=="" && b._config.score!==undefined && b._config.score!=="" && a._config.score!== b._config.score) {
							 if(a._config.score === b._config.store) {
								 return (""+a.lastName).localeCompare(b.lastName);
							 }
							 return b._config.score - a._config.score;
				}*/
			 return (""+a.lastName).localeCompare(b.lastName);
		} );
		return l;
	}



	render () {

		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		var ballte = this.state.dataStore.battle;

		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

		return (
			<div>

					<div className="row justify-content-end">
						<div className="col-6 text-left p-0"><button onClick={()=>{super.doChangeValue({},"OBS","toggleOBSPanel");}} className="btn btn-link"><img style={{maxWidth : '18px', maxHeight : '18px'}} src={_GPY.resource(this.state.components.OBS!==undefined&&this.state.components.OBS.state.showOBSPanel===true?"images/obs_green.png":"images/obs_black.png")} className="img-fluid" alt=""/></button></div>
						<div className="col-6 text-right"><button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target={"#gametype_"+this.state.NAME+"_scoreboard_games"} aria-expanded="false" aria-controls={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<span className="text-secondary">
						<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>&nbsp;
						{this.state.currentGame.id > 0 ? this.state.currentGame.gameName + " - " + moment(this.state.currentGame.startTime).locale('de').format('L') + " (" + moment(this.state.currentGame.startTime).locale(_GPY.locale).format('HH:mm') + "-"+  moment(this.state.currentGame.endTime).locale(_GPY.locale).format('HH:mm')+ ")":_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}
						&nbsp;<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>
						</span>
						</button></div>
					</div>

					<div className="collapse bg-light" id={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<div className="row justify-content-center pt-4">
								{this.state.gamesIsLoaded && this.state.games.Games.Game.length>0?
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}</h3></div>
								:
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_nogame_title')}</h3></div>
								}

								<div className="col-12 col-sm-12 col-md-8 col-xl-8">
									<div className="list-group">
										 {this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {

											 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {

												return (
												<button key={t.id} onClick={()=> {super.onSelectGame(t.id,this.reset())}} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
													<div className="row p-2">
													<div className="col-12 text-center"><span>{t.gameName} - {moment(t.startTime).locale('de').format('L')}  ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</span></div>
													</div>
												</button>);
											} else {
												return "";
											}

										 })  : "" }
									</div>
								</div>
						</div>
						<div className="row p-4">
							<div className="col border-top"></div>
							<div className="col-1 text-center text-muted"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/></div>
							<div className="col border-top"></div>
						</div>
				</div>

	<OBS className="mb-2" scoreboard={this}
					 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
					 getGameId={() => {return this.state.currentGame.id}} />




			{this.state.currentGame.id > 0 ?
			<div>
					<div className="row">
						<div className="col-9 p-2"/>
						<div className="col-1 p-2">
							<button className="btn btn-light btn-block m-0" onClick={()=>{
								var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
								var csv = '"Pos","Fahrer","Runde1","Runde2","Runde3"\n';
								for(var i = 0; i<players.length;i++) {
									var p = players[i];
									csv += '"'+(i+1)+'","'+_GPY.toPlayerName(p)+'"';

									if(this.state.dataStore!==undefined&&this.state.dataStore.player!==undefined&&this.state.dataStore.player[p.id]!==undefined){
										csv += ',"'+this.state.dataStore.player[p.id].quailifying_score[0]+'","'+this.state.dataStore.player[p.id].quailifying_score[1]+'","'+this.state.dataStore.player[p.id].quailifying_score[2] + '"\n';
									} else {
										csv += ',"0","0","0"\n';
									}
								}
								saveAs(new Blob([csv], {type: "text/plain;charset=utf-8"}),"Fahrer.csv");
							}}>ExportCSV</button>
						</div>
						<div className="col-2 p-2">
							<button className={"btn btn-"+(this.state.battleBoardMode?"success":"info")+" btn-block m-0"} onClick={()=>{this.setState({"battleBoardMode":!this.state.battleBoardMode})}}>{this.state.battleBoardMode?"Scoreboard":"Battleboard"}</button>
						</div>
					</div>

					 <div style={this.state.battleBoardMode?{display:"none"}:{}}>
								<div className="row">
									<div className="col pl-4" style={{maxWidth:(this.state.displayWidth+10)+"px"}}>

									 <div className="row">
												<div className="col-9 p-0 border border">
												<select className="form-control"  style={{zIndex:100}} onChange={super.changeLayout.bind(this)} value={this.state.currentLayout.id}>
													<option key="-1" value="-1">default</option>
													{this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
														<option key={t.id} value={t.id}>{t.name}</option>
													):""}
												</select>
												</div>
												<div className="col-3 p-0 border border">
													<button className="btn btn-outline-dark btn-block" onClick={this.reset.bind(this)}>Reset</button>
												</div>
												<div className="col-12 p-0 border border-white" style={{backgroundColor:"#ff6"}}>
														<Display onData={(data,key)=>{super.onData(key,data);}} width={this.state.displayWidth} height={Math.round(this.state.displayWidth/1.7777777778)} layoutId={this.state.currentLayout.id} stateName="__DISPLAY__" scoreboard={this}/>
												</div>
									</div>

									<div className="row">

											<div className="col-5 p-0 ">
												<h6>Lead</h6>
												{_GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{})}
											</div>

											<div className="col-2 p-0">
											VS
											</div>

											<div className="col-5 p-0">
													<h6>Chase</h6>
													{_GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_chase']!==undefined ? this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer:{})}
											</div>
									</div>

									<div className="row">

											<div className="col-5 p-0 ">
												{this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0?
												<GpyScoreField min="0" max="100" stateName="Drift_score_lead" scoreboard={this} getTime={ () => {return  0 } } 	getGameId={() => {return this.state.currentGame.id} } />
												:""}
											</div>
											<div className="col-2 p-0">
											<button className="btn btn-danger" onClick={()=>{
												if(this.state.components[this.state.NAME+'_score_lead']!==undefined)this.state.components[this.state.NAME+'_score_lead'].setScore(0);
												if(this.state.components[this.state.NAME+'_score_chase']!==undefined)this.state.components[this.state.NAME+'_score_chase'].setScore(0);
											}}>Reset</button>
											</div>
											<div className="col-5 p-0">
												{this.state.components[this.state.NAME+'_playerlist_chase']!==undefined && this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer.id>0?
													<GpyScoreField min="0" max="100" stateName="Drift_score_chase" scoreboard={this} getTime={ () => {return  0 } } 	getGameId={() => {return this.state.currentGame.id} } />
												:""}
											</div>
									</div>

									<div className="row mt-2">

											<div className="col-4 p-0 "><button className="btn btn-danger" onClick={()=>{
												if( this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_score_lead']!==undefined ) {
													var player =  this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer;
													var ds = this.state.dataStore;
													if(ds.player[player.id] === undefined){
														ds.player[player.id] = {quailifying_score:[0,0,0]}
													}
													ds.player[player.id].quailifying_score[0] = this.state.components[this.state.NAME+'_score_lead'].state.score;
													super.storeData();
												}
												this.setState({dataStore:ds});
											}}>Wertung R1</button>
											</div>
											<div className="col-4 p-0"><button className="btn btn-danger" onClick={()=>{
												if( this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_score_lead']!==undefined ) {
													var player =  this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer;
													var ds = this.state.dataStore;
													if(ds.player[player.id] === undefined){
														ds.player[player.id] = {quailifying_score:[0,0,0]}
													}
													ds.player[player.id].quailifying_score[1] = this.state.components[this.state.NAME+'_score_lead'].state.score;
													super.storeData();
												}
												this.setState({dataStore:ds});
											}}>Wertung R2</button></div>

											<div className="col-4 p-0"><button className="btn btn-danger" onClick={()=>{
												if( this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_score_lead']!==undefined ) {
													var player =  this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer;
													var ds = this.state.dataStore;
													if(ds.player[player.id] === undefined){
														ds.player[player.id] = {quailifying_score:[0,0,0]}
													}
													ds.player[player.id].quailifying_score[2] = this.state.components[this.state.NAME+'_score_lead'].state.score;
													super.storeData();
												}
												this.setState({dataStore:ds});
											}}>Wertung R3</button>
											</div>
									</div>

									<div className="row mt-5">
											<div className="col-4 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_qually_round_1')}
												onInit={() => {return {}}}
												condition={() => {return this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														round: "Round 1",
														playerName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{}),
														player: this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{},
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_quailifying_player_round_1"
												/>

											</div>
											<div className="col-4 p-0">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_qually_round_2')}
												onInit={() => {return {}}}
												condition={() => {return this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														round: "Round 2",
														playerName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{}),
														player: this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{},
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_quailifying_player_round_2"
											 />

											</div>

											<div className="col-4 p-0">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_qually_round_3')}
												onInit={() => {return {}}}
												condition={() => {return this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														round: "Round 3",
														playerName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{}),
														player: this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{},
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_quailifying_player_round_3"
											 />

											</div>
									</div>

									<div className="row mt-2">
							 				<div className="col-6 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_big_vs')}
												onInit={() => {return {}}}
												condition={() => {return this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0  && this.state.components[this.state.NAME+'_playerlist_chase']!==undefined && this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer.id>0}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														playerLeadName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{}),
														playerChaseName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_chase']!==undefined ? this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer:{}),
														playerLead: this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{},
														playerChase: this.state.components[this.state.NAME+'_playerlist_chase']!==undefined ? this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer:{},
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_big_vs"
												autoexpirytime="14"/>

											</div>
											<div className="col-6 p-0">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_small_vs')}
												onInit={() => {return {}}}
												condition={() => {return this.state.components[this.state.NAME+'_playerlist_lead']!==undefined && this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer.id>0  && this.state.components[this.state.NAME+'_playerlist_chase']!==undefined && this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer.id>0}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														playerLeadName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{}),
														playerChaseName: _GPY.toPlayerName(this.state.components[this.state.NAME+'_playerlist_chase']!==undefined ? this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer:{}),
														playerLead: this.state.components[this.state.NAME+'_playerlist_lead']!==undefined ? this.state.components[this.state.NAME+'_playerlist_lead'].state.selectedPlayer:{},
														playerChase: this.state.components[this.state.NAME+'_playerlist_chase']!==undefined ? this.state.components[this.state.NAME+'_playerlist_chase'].state.selectedPlayer:{},
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_small_vs"
												autoexpirytime="10"
											 />

											</div>
									</div>

									<div className="row  mt-2">
											<div className="col-12 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_battleboard_32')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {

													var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
													players = players.slice(0,32);
													var pobj = {};
													for(var i=0;i<players.length;i++) {
														pobj[players[i].id] = players[i];
													}

													var p32 = []
													for(var i=1;i<=32;i++) {
														p32[i] = _GPY.toPlayerName(pobj[ballte._32[i]]);
													}
													var p16 = []
													for(var i=1;i<=16;i++) {
														p16[i] = _GPY.toPlayerName(pobj[ballte._16[i]]);
													}
													var p8 = []
													for(var i=1;i<=8;i++) {
														p8[i] = _GPY.toPlayerName(pobj[ballte._8[i]]);
													}
													var p4 = []
													for(var i=1;i<=4;i++) {
														p4[i] = _GPY.toPlayerName(pobj[ballte._4[i]]);
													}
													var p2 = []
													for(var i=1;i<=4;i++) {
														p2[i] = _GPY.toPlayerName(pobj[ballte._2[i]]);
													}
													var p1 = []
													for(var i=1;i<=1;i++) {
														p1[i] = _GPY.toPlayerName(pobj[ballte._1[i]]);
													}
													return {visible: true,

														_32 : p32,
														_16 : p16,
														_8 :  p8,
														_4 :  p4,
														_2 :  p2,
														_1 : p1,
														eventName:"",
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_battleboard_32"
												autoexpirytime="20"/>

											</div>
									</div>

									<div className="row  mt-2">
											<div className="col-3 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_score_table_16')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);

													players = players.slice(0,16);
													console.log("Players",players);
													var txtList = ["Pos#TAB#Fahrer#TAB#Pts."];
													var count = 1;

													players.forEach((p)=>{
															txtList.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
															count++;
													});

													return {visible: true,
														playerScoreList : txtList,
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_score_table_16"
												autoexpirytime="20"/>

											</div>

											<div className="col-3 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_score_table_32')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);

													players = players.slice(17,33);
													console.log("Players",players);
													var txtList = ["Pos#TAB#Fahrer#TAB#Pts."];
													var count = 17;

													players.forEach((p)=>{
															txtList.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
															count++;
													});

													return {visible: true,
														playerScoreList : txtList,
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_button_score_table_32"
												autoexpirytime="20"/>

											</div>


									</div>

								<div className="row  mt-2">

								<div className="col-3 p-0 ">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_double_score_table')+" 0-32"}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {
										var offset = 0;
										var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
										var playersa = players.slice(offset,offset+16);
										var txtLista = ["Pos#TAB#Fahrer#TAB#Pts."];
										var count = offset+1;
										playersa.forEach((p)=>{
												txtLista.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										var playersb = players.slice(offset+17,offset+33);
										var txtListb = ["Pos#TAB#Fahrer#TAB#Pts."];

										playersb.forEach((p)=>{
												txtListb.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										return {visible: true,
											playerScoreListA : txtLista,
											playerScoreListB : txtListb,
											sponsorLogo: sponsorLogo,
										}}}
									scoreboard={this}
									getTime={ () => {return 0; } }
									getGameId={() => {return this.state.currentGame.id} }
									stateName="Drift_button_double_score_table_0"
									autoexpirytime="20"/>

								</div>

								<div className="col-3 p-0 ">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_double_score_table')+" 33-64"}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {
										var offset = 32;
										var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
										var playersa = players.slice(offset,offset+16);
										var txtLista = ["Pos#TAB#Fahrer#TAB#Pts."];
										var count = offset+1;
										playersa.forEach((p)=>{
												txtLista.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										var playersb = players.slice(offset+17,offset+33);
										var txtListb = ["Pos#TAB#Fahrer#TAB#Pts."];

										playersb.forEach((p)=>{
												txtListb.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										return {visible: true,
											playerScoreListA : txtLista,
											playerScoreListB : txtListb,
											sponsorLogo: sponsorLogo,
										}}}
									scoreboard={this}
									getTime={ () => {return 0; } }
									getGameId={() => {return this.state.currentGame.id} }
									stateName="Drift_button_double_score_table_32"
									autoexpirytime="20"/>

								</div>

								<div className="col-3 p-0 ">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_double_score_table')+" 65-96"}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {
										var offset = 64;
										var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
										var playersa = players.slice(offset,offset+16);
										var txtLista = ["Pos#TAB#Fahrer#TAB#Pts."];
										var count = offset+1;
										playersa.forEach((p)=>{
												txtLista.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										var playersb = players.slice(offset+17,offset+33);
										var txtListb = ["Pos#TAB#Fahrer#TAB#Pts."];

										playersb.forEach((p)=>{
												txtListb.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										return {visible: true,
											playerScoreListA : txtLista,
											playerScoreListB : txtListb,
											sponsorLogo: sponsorLogo,
										}}}
									scoreboard={this}
									getTime={ () => {return 0; } }
									getGameId={() => {return this.state.currentGame.id} }
									stateName="Drift_button_double_score_table_64"
									autoexpirytime="20"/>

								</div>

								<div className="col-3 p-0 ">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_double_score_table')+" 97-128"}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {
										var offset = offset+96;
										var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
										var playersa = players.slice(offset,offset+16);
										var txtLista = ["Pos#TAB#Fahrer#TAB#Pts."];
										var count = 1;
										playersa.forEach((p)=>{
												txtLista.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										var playersb = players.slice(offset+17,offset+33);
										var txtListb = ["Pos#TAB#Fahrer#TAB#Pts."];

										playersb.forEach((p)=>{
												txtListb.push( count + "#TAB#"+ _GPY.toPlayerName(p) + " #TAB# " + (this.state.dataStore.player[p.id]!==undefined&&this.state.dataStore.player[p.id].quailifying_score!==undefined?this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score):0));
												count++;
										});
										return {visible: true,
											playerScoreListA : txtLista,
											playerScoreListB : txtListb,
											sponsorLogo: sponsorLogo,
										}}}
									scoreboard={this}
									getTime={ () => {return 0; } }
									getGameId={() => {return this.state.currentGame.id} }
									stateName="Drift_button_double_score_table_96"
									autoexpirytime="20"/>

								</div>


								</div>

									<div className="row  mt-2">


									<div className="col-2 p-0 ">
									<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_session_free_training')}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false}}}
										onActivate={() => {
											return {visible: true,
												sessionName : "Freies Training",
												sponsorLogo: sponsorLogo,
											}}}
										scoreboard={this}
										getTime={ () => {return 0; } }
										getGameId={() => {return this.state.currentGame.id} }
										stateName="Drift_current_session_free_training"/>
									</div>

									<div className="col-2 p-0 ">
									<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_session_quailifying')}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false}}}
										onActivate={() => {
											return {visible: true,
												sessionName : "Qualifikation",
												sponsorLogo: sponsorLogo,
											}}}
										scoreboard={this}
										getTime={ () => {return 0; } }
										getGameId={() => {return this.state.currentGame.id} }
										stateName="Drift_current_session_quailifying"/>
									</div>

									<div className="col-2 p-0 ">
									<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_session_battle_16')}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false}}}
										onActivate={() => {
											return {visible: true,
												sessionName : "Top Battle 16",
												sponsorLogo: sponsorLogo,
											}}}
										scoreboard={this}
										getTime={ () => {return 0; } }
										getGameId={() => {return this.state.currentGame.id} }
										stateName="Drift_current_session_battle_16"/>
									</div>

											<div className="col-2 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_session_battle_32')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														sessionName : "Top Battle 32",
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_current_session_battle_32"/>
											</div>

											<div className="col-2 p-0 ">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_session_finals')}
												onInit={() => {return {}}}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true,
														sessionName : "Finals",
														sponsorLogo: sponsorLogo,
													}}}
												scoreboard={this}
												getTime={ () => {return 0; } }
												getGameId={() => {return this.state.currentGame.id} }
												stateName="Drift_current_session_finals"/>
											</div>

									</div>





									<div className="row">
											<div className="col-12 p-1">
													<div className="form-group">
														<label htmlFor="exampleFormControlTextarea1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_title')}</strong>‚</label>
														<textarea className="form-control" onChange={(e)=>{super.storeOnChangeFormData("_freeText",e)}} value={this.state._freeText} id="exampleFormControlTextarea1" rows="3"></textarea>
													</div>
											</div>
											</div>
											<div className="row">

												<div className="col-4 p-1">
													<button className="btn btn-light btn-sm  btn-block" onClick={()=>{

														var val = "";

														var players = this.sortPlayer(this.state.currentGame.players.Player,this.state.dataStore.player);
														for(var i = 0; i<players.length;i++) {
															var p = players[i];
															if(this.state.dataStore!==undefined&&this.state.dataStore.player!==undefined&&this.state.dataStore.player[p.id]!==undefined){
																val += (i+1)+' '+_GPY.toPlayerName(p) +  ' ' + (this.getMaxValue(this.state.dataStore.player[p.id].quailifying_score)) + ' Pts.\n';
															}
														}
														super.storeOnChangeFormData("_freeText",{target:{value:val}});
													}}>Gen Player Tab</button>
												</div>



											</div>
											<div className="row">

											<div className="col-6 p-1">
													<GpyToggleButton
															title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_button_text')}
															onInit={() => {return {}}}
															onDeactivate={() => {return {visible: false,text:""}}}
															onActivate={() => {return {visible: true,text: this.state._freeText}}}
															scoreboard={this}
															getTime={ () => {return  0 } }
															getGameId={() => {return -1} }
															stateName="Drift_button_freetext"/>
											</div>
											<div className="col-6 p-1">
													 <div className="row"><div className="col-6 pr-0">
																	<select style={{padding:"0.25rem 0.5rem",fontSize: "0.875rem",lineHeight:"1.5"}} className="custom-select" value={this.state.crawl_seperator} onChange={(e)=>this.setState({crawl_seperator:e.target.value})} id="inputGroupSelect01">
																		 <option selected value={this.state.currentGame.teamMap.HOME_TEAM.logo}>HomeLogo</option>
																		 <option value={this.state.currentGame.teamMap.GUEST_TEAM.logo}>GuestLogo</option>
																		 <option value={sponsorLogo}>sponsorLogo</option>
																		 <option value="point.png">point</option>
																		 <option value="star.png">star</option>
																		 <option value="empty.png">empty</option>
																	</select>
													 </div><div className="col-6 pl-0">
															<GpyToggleButton
																	title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_crawl_button_text')}
																	onInit={() => {return {}}}
																	onDeactivate={() => {return {visible: false,text:""}}}
																	onActivate={() => {return {visible: true,text: this.state._freeText,separatorImage:this.state.crawl_seperator!==undefined?this.state.crawl_seperator:this.state.currentGame.teamMap.HOME_TEAM.logo}}}
																	scoreboard={this}
																	getTime={ () => {return  0 } }
																	getGameId={() => {return -1} }
																	stateName="Drift_button_freetext_crawl"/>
														</div></div>
											</div>
											</div>







									</div>

									<div className="col pl-4" style={{maxWidth:(this.state.displayWidth+10)+"px"}}>
														<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_title_lead')}</strong>
														<GpyTeamList additionalClass=" p-1" displayQuailifyingScore="true" sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} scoreboard={this} disableRcvSelect="true" exclusionRoles="HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerlist_lead'}/>
									</div>
									<div className="col pl-4" style={{maxWidth:(this.state.displayWidth+10)+"px"}}>
														<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_title_chase')}</strong>
														<GpyTeamList additionalClass=" p-1" sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} scoreboard={this} disableRcvSelect="true" color="warning" exclusionRoles="HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerlist_chase'}/>
									</div>
								</div>

					 </div>



					<div style={!this.state.battleBoardMode?{display:"none"}:{}}>
					{/** - -- - - - - - - - - - - - - - -  - - ballteboard */}

					<div className="row">
					<div className="col-8 p-2 pt-1"/>
					<div className="col-2 p-2 pt-1"><button className="btn btn-danger btn-block m-0" onClick={()=>{
						ballte._32 = [];
						ballte._16 = [];
						ballte._8 = [];
						ballte._4 = [];
						ballte._2 = [];
						super.storeData();this.forceUpdate()}}>REST</button></div>
					<div className="col-2 p-2 pt-1"><button className="btn btn-primary btn-block m-0" onClick={()=>{this.calcTop32();super.storeData();}}>Setup Top32</button></div>
					</div>



							<div className="row">
								<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[1] = s; super.storeData();}} getValue={()=>{return ballte._32[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_1'}/></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[17] = s; super.storeData();}} getValue={()=>{return ballte._32[17]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_17'}/></div>
							</div>

							<div className="row">
								<div className="col-1"></div>
								<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} filter={(p) => this.playerContains( p, ballte._32[1], ballte._32[2], ballte) }  setValue={(s)=>{ballte._16[1] = s; super.storeData();}} getValue={()=>{return ballte._16[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_1'}/></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"></div>
								<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[9] = s; super.storeData();}} getValue={()=>{return ballte._16[9]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_9'}/></div>
								<div className="col-1"></div>
							</div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[2] = s; super.storeData();}} getValue={()=>{return ballte._32[2]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_2'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[18] = s; super.storeData();}} getValue={()=>{return ballte._32[18]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_18'}/></div>
							 </div>

							 <div className="row">
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._8[1] = s; super.storeData();}} getValue={()=>{return ballte._8[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_1'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._8[5] = s; super.storeData();}} getValue={()=>{return ballte._8[5]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_5'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[3] = s; super.storeData();}} getValue={()=>{return ballte._32[3]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_3'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[19] = s; super.storeData();}} getValue={()=>{return ballte._32[19]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_19'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[2] = s; super.storeData();}} getValue={()=>{return ballte._16[2]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_2'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[10] = s; super.storeData();}} getValue={()=>{return ballte._16[10]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_10'}/></div>
								 <div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[4] = s; super.storeData();}} getValue={()=>{return ballte._32[4]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_4'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[20] = s; super.storeData();}} getValue={()=>{return ballte._32[20]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_20'}/></div>
							 </div>

							 <div className="row">
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._4[1] = s; super.storeData();}} getValue={()=>{return ballte._4[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_4_1'}/></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._4[3] = s; super.storeData();}} getValue={()=>{return ballte._4[3]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_4_3'}/></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 		 <div className="col-1"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[5] = s; super.storeData();}} getValue={()=>{return ballte._32[5]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_5'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[21] = s; super.storeData();}} getValue={()=>{return ballte._32[21]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_21'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[3] = s; super.storeData();}} getValue={()=>{return ballte._16[3]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_3'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[11] = s; super.storeData();}} getValue={()=>{return ballte._16[11]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_11'}/></div>
								 <div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[6] = s; super.storeData();}} getValue={()=>{return ballte._32[6]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_6'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[22] = s; super.storeData();}} getValue={()=>{return ballte._32[22]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_22'}/></div>
							 </div>


							 <div className="row">
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._8[2] = s; super.storeData();}} getValue={()=>{return ballte._8[2]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_2'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._8[6] = s; super.storeData();}} getValue={()=>{return ballte._8[6]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_6'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[7] = s; super.storeData();}} getValue={()=>{return ballte._32[7]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_7'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[23] = s; super.storeData();}} getValue={()=>{return ballte._32[23]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_23'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[4] = s; super.storeData();}} getValue={()=>{return ballte._16[4]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_4'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._2[1] = s; super.storeData();}} getValue={()=>{return ballte._2[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_2_1'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._2[3] = s; super.storeData();}} getValue={()=>{return ballte._2[3]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_2_3'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[12] = s; super.storeData();}} getValue={()=>{return ballte._16[12]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_12'}/></div>
								 <div className="col-1"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[8] = s; super.storeData();}} getValue={()=>{return ballte._32[8]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_8'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[24] = s; super.storeData();}} getValue={()=>{return ballte._32[24]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_24'}/></div>
							 </div>

							 <div className="row">
							 			<div className="col-5"></div>
										<div className="col-2"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._1[1] = s; super.storeData();}} getValue={()=>{return ballte._1[1]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_1_1'}/></div>
										<div className="col-5"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[9] = s; super.storeData();}} getValue={()=>{return ballte._32[9]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_9'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[25] = s; super.storeData();}} getValue={()=>{return ballte._32[25]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_25'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[5] = s; super.storeData();}} getValue={()=>{return ballte._16[5]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_5'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[13] = s; super.storeData();}} getValue={()=>{return ballte._16[13]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_13'}/></div>
								 <div className="col-1"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[10] = s; super.storeData();}} getValue={()=>{return ballte._32[10]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_10'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[26] = s; super.storeData();}} getValue={()=>{return ballte._32[26]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_26'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._8[3] = s; super.storeData();}} getValue={()=>{return ballte._8[3]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_3'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._2[2] = s; super.storeData();}} getValue={()=>{return ballte._2[2]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_2_2'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{alert(s);ballte._2[4] = s; super.storeData();}} getValue={()=>{return ballte._2[4]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_2_4'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._8[7] = s; super.storeData();}} getValue={()=>{return ballte._8[7]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_7'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[11] = s; super.storeData();}} getValue={()=>{return ballte._32[11]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_11'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[27] = s; super.storeData();}} getValue={()=>{return ballte._32[27]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_27'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[6] = s; super.storeData();}} getValue={()=>{return ballte._16[6]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_6'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[14] = s; super.storeData();}} getValue={()=>{return ballte._16[14]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_14'}/></div>
								 <div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[12] = s; super.storeData();}} getValue={()=>{return ballte._32[12]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_12'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[28] = s; super.storeData();}} getValue={()=>{return ballte._32[28]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_28'}/></div>
							 </div>

							 <div className="row">
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._4[2] = s; super.storeData();}} getValue={()=>{return ballte._4[2]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_4_2'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._4[4] = s; super.storeData();}} getValue={()=>{return ballte._4[4]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_4_4'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[13] = s; super.storeData();}} getValue={()=>{return ballte._32[13]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_13'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[29] = s; super.storeData();}} getValue={()=>{return ballte._32[29]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_29'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[7] = s; super.storeData();}} getValue={()=>{return ballte._16[7]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_7'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[15] = s; super.storeData();}} getValue={()=>{return ballte._16[15]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_15'}/></div>
								 <div className="col-1"></div>
							 </div>


							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[14] = s; super.storeData();}} getValue={()=>{return ballte._32[14]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_14'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[30] = s; super.storeData();}} getValue={()=>{return ballte._32[30]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_30'}/></div>
							 </div>


							 <div className="row">
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._8[4] = s; super.storeData();}} getValue={()=>{return ballte._8[4]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_4'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._8[8] = s; super.storeData();}} getValue={()=>{return ballte._8[8]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_8_8'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[15] = s; super.storeData();}} getValue={()=>{return ballte._32[15]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_15'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[31] = s; super.storeData();}} getValue={()=>{return ballte._32[31]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_31'}/></div>
							 </div>

							 <div className="row">
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._16[8] = s; super.storeData();}} getValue={()=>{return ballte._16[8]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_8'}/></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"></div>
								 <div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._16[16] = s; super.storeData();}} getValue={()=>{return ballte._16[16]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_16_16'}/></div>
								 <div className="col-1"></div>
							 </div>

							 <div className="row">
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)}  setValue={(s)=>{ballte._32[16] = s; super.storeData();}} getValue={()=>{return ballte._32[16]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_16'}/></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"></div>
										<div className="col-1"><GpyTeamSelect sorter={(l)=>this.sortPlayer(l,this.state.dataStore.player)} setValue={(s)=>{ballte._32[32] = s; super.storeData();}} getValue={()=>{return ballte._32[32]}} scoreboard={this} game={this.state.currentGame} vsRole="GAME_PLAYER" stateName={this.state.NAME+'_playerselect_32_32'}/></div>
							 </div>


					{/** - -- - - - - - - - - - - - - - -  - - ballteboard */}
					</div>


		 </div>

			:<div>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_warn_message_selectgame')}</div>}

</div>
			);
	}

}
export default SBDrift;
